import { render, staticRenderFns } from "./Desechos.vue?vue&type=template&id=8d953f18&"
import script from "./Desechos.vue?vue&type=script&lang=ts&"
export * from "./Desechos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports